import { render, staticRenderFns } from "./GroupRole.vue?vue&type=template&id=c68c06a0&"
import script from "./GroupRole.vue?vue&type=script&lang=js&"
export * from "./GroupRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports